import {
  Box,
  Text,
  VStack,
  HStack,
  Flex,
  Avatar,
  Button,
  Icon,
  Grid,
  Tooltip,
} from '@chakra-ui/react'
import {BsExclamationCircle} from 'react-icons/bs'
import AvatarDefault from '@assets/images/avatar-msg-part-two.png'

const BandScoreMsg = ({msg}: {msg: any}) => {
  return (
    <HStack align="start" spacing={4}>
      <Avatar
        src={AvatarDefault}
        size="sm"
        borderRadius={'50%'}
        border={'2px solid #E4E7EC'}
      />
      <VStack
        maxWidth={'80%'}
        align="start"
        spacing={4}
        bg={'white'}
        p={'16px'}
        borderRadius={'12px'}>
        <Flex alignItems="center" gap={2} fontWeight={600}>
          <Text fontSize={'16px'}>Mình dự đoán bài nói của bạn</Text>
          <Text fontSize={'18px'} color="blue.500" fontWeight="600">
            đạt {msg?.overall.toFixed(1)}
          </Text>
          <Text fontSize={'16px'}>trên band điểm IELTS</Text>
          <Tooltip label="Phần điểm mang tính chất tham khảo. Để biết điểm chính xác hơn, hãy sử dụng phần thi thử.">
            <Box>
              <Icon
                as={(BsExclamationCircle as any) || <></>}
                color="#98A2B3"
                boxSize="20px"
                cursor="pointer"
              />
            </Box>
          </Tooltip>
        </Flex>
        <Text color="gray.500" fontSize={'16px'}>
          Hãy xem nhận xét chi tiết ở dưới để cải thiện thêm
        </Text>

        <Grid templateColumns="repeat(2, 1fr)" gap={4} w="full">
          <VStack align="start">
            <Text color="blue.400" fontWeight="600" fontSize={'16px'}>
              FLUENCY & COHERENCE
            </Text>
            {msg?.fluency
              ?.split('-')
              .filter((point: string) => point.trim())
              .map((point: string, idx: number) => (
                <Text key={idx} as={'span'} fontSize={'16px'}>
                  - {point.trim()}
                </Text>
              ))}
          </VStack>

          <VStack align="start">
            <Text color="blue.400" fontWeight="600" fontSize={'16px'}>
              VOCABULARY
            </Text>
            <Text fontSize={'16px'}>
              {msg?.vocabulary
                ?.split('-')
                .filter((point: string) => point.trim())
                .map((point: string, idx: number) => (
                  <Text key={idx} as={'span'} fontSize={'16px'}>
                    - {point.trim()}
                  </Text>
                ))}
            </Text>
          </VStack>

          <VStack align="start">
            <Text color="blue.400" fontWeight="600" fontSize={'16px'}>
              GRAMMAR
            </Text>
            <Text fontSize={'16px'}>
              {msg?.grammar
                ?.split('-')
                .filter((point: string) => point.trim())
                .map((point: string, idx: number) => (
                  <Text key={idx} as={'span'} fontSize={'16px'}>
                    - {point.trim()}
                  </Text>
                ))}
            </Text>
          </VStack>

          <VStack align="start">
            <Text color="blue.400" fontWeight="600">
              PRONUNCIATION
            </Text>
            <Text fontSize={'16px'}>
              {msg?.pronunciation
                ?.split('-')
                .filter((point: string) => point.trim())
                .map((point: string, idx: number) => (
                  <Text key={idx} as={'span'} fontSize={'16px'}>
                    - {point.trim()}
                  </Text>
                ))}
            </Text>
          </VStack>
        </Grid>
      </VStack>
    </HStack>
  )
}

export default BandScoreMsg
